export const anonymousRoutes = [
  {
    path: '/',
    name: 'homepage'
    // No component, a router guard is handling this route. We may use splashscreen later.
  },
  {
    path: '/accept-cgu',
    name: 'accept-cgu',
    component: () => import('src/modules/core/views/AcceptCgu.vue')
  },
  {
    name: 'auth-error',
    path: '/auth-error',
    component: () => import('src/modules/core/views/ErrorAuth.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    redirect: '/'
  }
]
